import {
  DarkTheme,
  DefaultTheme,
  NavigationContainer,
} from '@react-navigation/native'
import { useAuthentication } from 'authentication/context'
import React from 'react'
import { useThemeChange } from 'settings/change_theme'
import Loading from 'shared/components/loading'
import { linking, navigationRef } from './linking'
import Root from './root'
import { routingInstrumentation } from './sentry'

export function Navigation() {
  const { status: authStatus } = useAuthentication()
  const { dark } = useThemeChange()

  return (
    <NavigationContainer
      linking={linking}
      fallback={<Loading />}
      theme={dark ? DarkTheme : DefaultTheme}
      ref={navigationRef}
      onReady={() => {
        routingInstrumentation.registerNavigationContainer(navigationRef)
      }}
    >
      {authStatus === 'loading' ? (
        <Loading />
      ) : (
        <Root navigationRef={navigationRef} />
      )}
    </NavigationContainer>
  )
}
